export const SET_USERINFO = 'SET_USERINFO'
export const SET_TO_LOGIN_AS_ADMIN = 'SET_TO_LOGIN_AS_ADMIN'
export const SET_USER_MOBILE = 'SET_USER_MOBILE'
export const SET_PERMISSION = 'SET_PERMISSION'

